export default {
  LEADERBOARD_CONTAINER: 'LEADERBOARD_CONTAINER',
  LEADERBOARD_CLOSE_CLICK: 'LEADERBOARD_CLOSE_CLICK',
  LEADERBOARD_REFRESH_CLICK: 'LEADERBOARD_REFRESH_CLICK',
  OBJECTIVES_CONTAINER: 'OBJECTIVES_CONTAINER',
  OBJECTIVES_CLOSE_CLICK: 'OBJECTIVES_CLOSE_CLICK',
  SENDEMAILREPORT_CONTAINER: 'SENDEMAILREPORT_CONTAINER',
  SENDEMAILREPORT_EMAIL_INPUT: 'SENDEMAILREPORT_EMAIL_INPUT',
  SENDEMAILREPORT_SEND_CLICK: 'SENDEMAILREPORT_SEND_CLICK',
  TUTORIAL_CONTAINER: 'TUTORIAL_CONTAINER',
  TUTORIAL_NEXT_CLICK: 'TUTORIAL_NEXT_CLICK',
  TUTORIAL_PREV_CLICK: 'TUTORIAL_PREV_CLICK',
  TUTORIAL_FINISH_CLICK: 'TUTORIAL_FINISH_CLICK',
};



